@if (repo.resource$ | async; as data) {
  <div>
    <!-- Scheduled monitoring table -->
    @if (data.length > 0) {
      <table mat-table matSort (matSortChange)="sort($event)" [dataSource]="data" multiTemplateDataRows>
        <ng-container matColumnDef="icon">
          <th mat-header-cell *matHeaderCellDef> </th>
          <td mat-cell *matCellDef="let monitor">
            <mat-icon [class]="getIconClass(monitor)">{{ getIcon(monitor) }}</mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="automationName">
          <th mat-header-cell mat-sort-header *matHeaderCellDef id="automationName"> {{ 'scheduledMonitors.processName' | transloco }} </th>
          <td mat-cell *matCellDef="let monitor"> {{ monitor.automationName }} </td>
        </ng-container>
        <ng-container matColumnDef="scheduledFrequency">
          <th mat-header-cell *matHeaderCellDef id="scheduledFrequency"> {{ 'scheduledMonitors.runFrequency' | transloco }} </th>
          <td mat-cell *matCellDef="let monitor"> {{ 'scheduledMonitors.everyNHours' | transloco: { hours: monitor.scheduledFrequency } }} </td>
        </ng-container>
        <ng-container matColumnDef="warningFrequency">
          <th mat-header-cell *matHeaderCellDef id="warningFrequency"> {{ 'scheduledMonitors.warningFrequency' | transloco }} </th>
          <td mat-cell *matCellDef="let monitor"> {{ 'scheduledMonitors.everyNHours' | transloco: { hours: monitor.warningFrequency } }} </td>
        </ng-container>
        <ng-container matColumnDef="lastSuccessfulRunDate">
          <th mat-header-cell mat-sort-header *matHeaderCellDef id="lastSuccessfulRunDate"> {{ 'scheduledMonitors.lastSuccessfulRun' | transloco }} </th>
          <td mat-cell *matCellDef="let monitor"> {{ monitor.lastSuccessfulRunDate | localizedDate: 'yyyy-MM-dd hh:mm' }} </td>
        </ng-container>
        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef [attr.aria-label]="'common.labels.rowActions' | transloco">&nbsp;</th>
          <td mat-cell *matCellDef="let monitor">
            <button mat-icon-button color="accent" (click)="onDeleteMonitor(monitor)" [attr.aria-label]="'scheduledMonitors.deleteMonitor' | transloco">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    }
    <!-- End of scheduled monitoring table -->
    <div class="spacer-small"></div>
    @if (data.length > 0) {
      <mat-paginator [pageSize]="this.repo.pageSize$ | async"
        [length]="this.repo.resourceCount$ | async" [pageIndex]="this.repo.pageNum$ | async"
        [pageSizeOptions]="[5, 10, 25]" [showFirstLastButtons]="((this.repo.totalPages$ | async) ?? 1) > 2"
      (page)="page($event)"></mat-paginator>
    }
  </div>
}